import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, PreSOJobsActions, PreSOJobsMutations } from './types';
import PreSOJobService from '@/shared/services/PreSOJobService';
import Cloner from '@/shared/helpers/cloner';
import { ServiceOrderActions } from '../service-order/types';
import { UserGetters } from '../user/types';
const _actions = namespaceHelper.removeNamespace(namespace, PreSOJobsActions);
const _mutations = namespaceHelper.removeNamespace(namespace, PreSOJobsMutations);
const _serviceOrderActions = namespaceHelper.removeNamespace(namespace, ServiceOrderActions);

export default {
  async [_actions.FETCH_PRE_SO_JOBS_COUNT]({ commit }) {
    let user = this.getters[UserGetters.GET_USER_PROFILE];
    const branchesList = user.employeeBranches.map(branch => branch.branchId);
    const result = await PreSOJobService.fetchPreSOJobsCount({ branchIds: branchesList });
    commit(_mutations.SET_PRE_SO_JOBS_COUNT, result.data);
  },
  async [_actions.FETCH_PRE_SO_JOBS]({ commit }, params) {
    const result = await PreSOJobService.fetchPreSOJobs(params);
    commit(_mutations.SET_PRE_SO_JOBS, result.data);
  },
  async [_actions.FETCH_UNIT_PRE_SO_JOBS]({ commit }, unitId) {
    const result = await PreSOJobService.fetchUnitPreSOJobs(unitId);
    commit(_mutations.SET_UNIT_PRE_SO_JOBS, result.data);
  },
  async [_actions.ADD_PRE_SO_JOBS_TO_SO]({ dispatch }, params) {
    const clonedJobs = Cloner.deepClone(params.jobs);
    const selectedJobs = clonedJobs.filter(job => job.isSelected);
    selectedJobs.forEach(job => {
      job.serviceOrderId = params.serviceOrderId;
    });
    const result = await PreSOJobService.addPreSOJobsToSO(selectedJobs);
    await dispatch(
      _serviceOrderActions.SET_SERVICE_ORDER,
      { serviceOrder: result.data, _showDetails: false },
      { root: true }
    );
  },
  async [_actions.UPDATE_PRE_SO_JOB_VIN]({ commit }, params) {
    const { jobId, unitId, vin, fleetUnitId, customerId, customerName } = params;
    await PreSOJobService.updatePreSOJobVin(jobId, {
      unitId,
      vin,
      fleetUnitId,
      customerId,
      customerName
    });
    const updatedJob = {
      id: jobId,
      unitId,
      vin,
      fleetUnitId,
      customerId,
      customerName,
      vinValidated: true,
      customerValidated: true
    };
    commit(_mutations.UPDATE_PRE_SO_JOB_VIN, updatedJob);
  }
};
